import { render, staticRenderFns } from "./PricingTableTitleBlock.vue?vue&type=template&id=de7bd3a2&"
import script from "./PricingTableTitleBlock.vue?vue&type=script&lang=js&"
export * from "./PricingTableTitleBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports